export default __webpack_public_path__ + "static/media/DeFi.6b4e51e0.png";